<div class="row g-3 ">
	<!-- Page Title -->
	<div class="col-12 col-md-12">
		<div class="card h-100 pageTitleCard">
			<div class="card-body">
				<h4 class="card-title">{{contentStrings['MyMCXPortal'][language]}}</h4>
			</div>	
		</div>
	</div>
</div>
	
<div class="row g-3 ">
	<!-- User Info Card -->
	<app-property-overview-widget class="col-12 col-md-3"></app-property-overview-widget>
	<!-- Calendar -->
	<div class="col-12 col-md-4">
		<div class="card h-100">
			<div class="card-body">
				<h5 class="card-title">{{contentStrings['CommunityCalendar'][language]}}</h5>
				<div>
					<app-community-calendar></app-community-calendar>
				</div>
			</div>
		</div>
	</div>
	<!-- Payments Overview -->
	<div class="col-12 col-md-5">
		<app-payments-overview>	</app-payments-overview>
	</div>
</div>



<div class="row g-3 mt-1">
	<!-- My Work Orders -->
	<app-my-work-orders displayContext="widget"></app-my-work-orders>

</div>